import * as React from 'react';
// import MapContainer from '../../../components/controls/map/MapContainer';
// import GISData from '../../gis/GISData';

class MappingPage extends React.Component<{}> {
    public render() {
        return (
            // <MapContainer />

            // <iframe
            //     src="http://127.0.0.1:5173/"
            //     frameBorder="0"
            //     style={{ width: '100%', height: '100vh' }}
            //     title="Embedded Content"
            // />

            // <GISData />

            <iframe
                src="http://127.0.0.1:5173/"
                style={{ width: '100%', height: '100vh' }}
                title="Embedded Content"
            />

        );
    }
}

export default MappingPage;



// WEBPACK FOOTER //
// ./src/components/project/sections/Mapping.tsx